var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomogeneityOfVariancesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#272D55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 7.80001C5.575 8.02501 5.5 10.85 5.5 18.975C5.5 29.4 5.525 29.9 6 30.7C6.275 31.15 6.85 31.725 7.3 32C8.1 32.475 8.525 32.5 21.1 32.45C33.15 32.375 34.1 32.35 34.35 31.95C34.55 31.625 34.55 31.375 34.35 31.075C34.1 30.65 33.1 30.625 21.15 30.5C8.7 30.375 8.2 30.35 7.85 29.9C7.55 29.5 7.5 27.55 7.5 18.75C7.5 7.75002 7.475 7.50002 6.5 7.50002C6.275 7.50002 5.975 7.62502 5.8 7.80001Z",
    fill: "#E3ECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1001 11.6C9.92509 13.775 12.0001 17.2 15.0501 16.425C15.9501 16.2 16.1251 16.275 20.4501 19C24.7501 21.7 24.9251 21.85 25.2001 22.85C26.1251 26.3 31.0001 25.8 31.0001 22.25C31.0001 21.125 30.4001 20.125 29.4001 19.65C28.3251 19.15 27.7501 19.15 26.7001 19.65L25.8751 20.025L21.5001 17.3C18.5751 15.45 17.1251 14.4 17.1001 14.075C17.0751 13.825 17.0501 13.35 17.0251 13.025C17.0001 12.725 16.6251 12.075 16.1501 11.6C15.4251 10.875 15.1251 10.75 14.1251 10.75C13.1251 10.75 12.8251 10.875 12.1001 11.6Z",
    fill: "#E3ECFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 18.225C12.6752 18.85 12.9002 19.425 13.5252 19.625C14.4752 19.925 15.1502 18.75 14.4502 18.05C14.0002 17.6 13.3002 17.7 13.0002 18.225Z",
    fill: "#E3ECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.15 22.625C12.675 23.125 12.65 23.275 13.075 23.85C13.725 24.75 15.175 23.75 14.6 22.8C14.225 22.225 13.65 22.15 13.15 22.625Z",
    fill: "#E3ECFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.15 27.125C12.675 27.625 12.65 27.775 13.075 28.35C13.725 29.25 15.175 28.25 14.6 27.3C14.225 26.725 13.65 26.65 13.15 27.125Z",
    fill: "#E3ECFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3751 27.15C26.9001 27.65 26.9751 28.225 27.5751 28.6C28.4251 29.15 29.4001 27.925 28.7501 27.125C28.3501 26.65 27.8751 26.65 27.3751 27.15Z",
    fill: "#E3ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomogeneityOfVariancesOperationIcon);
export default __webpack_public_path__ + "static/media/HomogeneityOfVariancesOperationIcon.4d059801acaa88cbddf4c64d2d8d31ab.svg";
export { ForwardRef as ReactComponent };